import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Box from '@mui/material/Box';
import { DiskCleanupScanInfo_scanInfo$key } from '__generated__/DiskCleanupScanInfo_scanInfo.graphql';

type Props = {
  cleanInfo: DiskCleanupScanInfo_scanInfo$key;
  title?: string;
};

const DiskCleanupScanInfo: FC<Props> = props => {
  const { cleanInfo, title = 'Nuotraukos' } = props;

  const { count, size } = useFragment(
    graphql`
      fragment DiskCleanupScanInfo_scanInfo on CleanInfo {
        count
        size
      }
    `,
    cleanInfo
  );

  return (
    <>
      <Box>
        {title}: {count}
      </Box>

      <Box>Dydis: {size}</Box>
    </>
  );
};

export default DiskCleanupScanInfo;
